import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faFileShield, faPen, faShieldHalved } from '@fortawesome/free-solid-svg-icons';

export const getMenuItems = ({ record, actions, isCreated }) => {
  const certificates = record.certificates ?? [];

  const menuItems = [
    {
      label: 'Configuración',
      key: 'updateCredentials',
      icon: <FontAwesomeIcon icon={faPen} />,
      onClick: actions.onUpdateCredentials,
      visible: isCreated,
    },
    {
      label: 'Ver configuración',
      key: 'viewCredentials',
      icon: <FontAwesomeIcon icon={faEye} />,
      onClick: actions.onViewCredentials,
      visible: isCreated,
    },
    {
      label: `Cargar certificado${certificates.length > 1 ? 's' : ''}`,
      key: 'uploadCertificate',
      icon: <FontAwesomeIcon icon={faFileShield} />,
      onClick: actions.onUploadCertificate,
      visible: isCreated && certificates.length > 0,
    },
    {
      label: 'Agregar aseguradora',
      key: 'addInsuranceCarrier',
      icon: <FontAwesomeIcon icon={faShieldHalved} />,
      onClick: actions.onAddInsuranceCarrier,
      visible: !isCreated,
    },
  ];

  return menuItems;
};
